import { Panel } from '@/components/Atoms/Panel/Panel';
import styled from 'styled-components';

/**
 * A panel to be used to provide an introductory context in pages.
 */
export const IntroPanel = styled(Panel)<{ $barHeight?: string }>`
    position: relative;
    &:after {
        content: '';
        display: inline-block;
        position: absolute;
        right: calc(-1 * var(--size-grid-half));
        width: 0;
        top: 0;
        height: ${({ $barHeight }) => $barHeight || '80%'};
        border-right: solid var(--size-grid-unit) var(--color-body-accent);
    }
`;
